(function () {
  function ready(fn) {
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", fn);
    else fn();
  }
  ready(function () {
    var zoom = document.querySelector("[data-nr-zoom]");
    if (!zoom) return;
    var img = zoom.querySelector("img");
    document.querySelectorAll("[data-nr-zoom-src]").forEach(function (btn) {
      btn.addEventListener("click", function () {
        img.src = btn.getAttribute("data-nr-zoom-src");
        zoom.classList.add("open");
      });
    });
    zoom.addEventListener("click", function (e) {
      if (e.target === zoom || e.target.closest("[data-nr-zoom-close]")) zoom.classList.remove("open");
    });
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape") zoom.classList.remove("open");
    });
  });
})();
